import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

function NavigationAnnouncer() {
  // the message that will be announced
  const [message, setMessage] = useState("");
  // get location from router
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.slice(1)) {
      setTimeout(
        () => setMessage(`Navigated to ${location.pathname.slice(1)} page.`),
        500
      );
    } else {
      setMessage("");
    }
  }, [location]);

  return (
    // .sr-only comes from Tailwind CSS and makes sure it will only be visible for SRs
    <span
      className="sr-only"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {message}
    </span>
  );
}

export default NavigationAnnouncer;
